import {TotalPriceItem} from "../../components/items/total-price-item/total-price-item"
import {CartItem} from "../../components/items/cart-item/cart-item"
import {cartApi, cartData} from "./../cart-api/cart-api"
import {rerenderCartDropdown} from "./../cart-dropdown/cart-dropdown--rerender"
import {rerenderProgresses} from "../../components/items/progress-item/progress-item";

const carts = document.querySelectorAll(".s-cart")

carts.forEach((cart) => {
  const totalPrice = new TotalPriceItem(cart.querySelector(".i-total-price"))

  const items = cart.querySelectorAll<HTMLElement>(".i-cart")

  items.forEach((item) => {
    const cartItem = new CartItem(item)
    const productId = item.dataset.productId ?? null
    const mass = item.dataset.mass ?? null
    const counterInput = item.querySelector<HTMLInputElement>(".c-counter__input")
    const deleteButton = item.querySelector(".--js-cart-remove")

    counterInput?.addEventListener("change", async () => {
      if (!productId) {
        console.log("product id is missing")
        return
      }

      const quantity = Number(counterInput.value)

      cart.classList.add("--loading")

      const response = quantity > 0
        ? await cartApi.change(productId, mass, quantity)
        : await cartApi.delete(productId, mass)

      if (response.ok) {
        const data = (await response.json()) as cartData

        if (!data.success) {
          cart.classList.remove("--loading")
          return
        }

        rerenderCartDropdown(data.headerDropdown, data.totalPrice.main, data.amount)

        rerenderProgresses(data.progress.remaining, Number(data.progress.percentage))

        if (quantity > 0) {
          cartItem.setPriceBase(data.product.base)
          cartItem.setPriceMain(data.product.main)
          cartItem.setPriceBefore(data.product.before)
        }
        else {
          item.remove()
        }

        console.log(totalPrice)
        totalPrice.setBaseValue(data.totalPrice.base)
        totalPrice.setMainValue(data.totalPrice.main)

      }

      cart.classList.remove("--loading")
    })

    deleteButton?.addEventListener("click", async (event: Event) => {
      event.preventDefault()
      cart.classList.add("--loading")

      if (!productId) {
        console.log("product id is missing")
        return
      }

      const response = await cartApi.delete(productId, mass)

      if (response.ok) {
        const data = (await response.json()) as cartData

        if (!data.success) {
          cart.classList.remove("--loading")
          return
        }

        if (data.headerDropdown) rerenderCartDropdown(data.headerDropdown, data.totalPrice.main, data.amount)

        if(data.progress) rerenderProgresses(data.progress.remaining, Number(data.progress.percentage))

        item.remove()

        totalPrice.setBaseValue(data.totalPrice.base)
        totalPrice.setMainValue(data.totalPrice.main)
      }

      cart.classList.remove("--loading")
    })
  })
})
